<script setup lang="ts">
import {type Media, MediaType} from "~/repository/types.d";
import VideoReel from "~/components/ui/video/VideoReel.vue";
import {IconPlay} from "~/components/ui/icons";

const props = defineProps<{
  media: Media,
  postId: number;
}>()

const {sendEvent} = useEventLogger();
const imageRef = ref(null);
const isVisible = ref(false);

function preventSave(event: Event) {
  event.preventDefault();
}

useIntersectionObserver(imageRef, ([{isIntersecting}]) => {
  if (isIntersecting && !isVisible.value) {
    isVisible.value = true;
    sendEvent("image_view", props.postId);
  }
});
</script>

<template>
  <div class="text-white">
  </div>

  <div v-if="media.type === MediaType.IMAGE"
       class="before:absolute before:inset-0 before:z-40 z-20 relative post-background w-full h-full" ref="imageRef">
    <NuxtImg
      v-if="!media.has_access"
      :postId="postId"
      :src="media.url"
      @contextmenu="preventSave"
      @dragstart="preventSave"
      @touchstart="preventSave"
      class="block w-full h-full object-cover md:rounded-xl"/>
    <NuxtImg
      :postId="postId"
      :src="media.url"
      @contextmenu="preventSave"
      @dragstart="preventSave"
      @touchstart="preventSave"
      class="block w-full h-full object-cover md:rounded-xl"/>
  </div>
  <div v-else-if="media.type === MediaType.VIDEO"
       class="before:absolute before:inset-0 before:z-40 z-20 relative post-background w-full h-full">
    <div class="contents" v-if="!media.has_access" ref="imageRef">
      <NuxtImg
        :src="media.url"
        @contextmenu="preventSave"
        @dragstart="preventSave"
        @touchstart="preventSave"
        class="block w-full h-full object-cover"/>
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
        <button
          class="text-white rounded-full p-3 hover:cursor-not-allowed">
          <IconPlay size="50px"/>
        </button>
      </div>
    </div>
    <!--    @contextmenu="preventSave"-->
    <!--    @dragstart="preventSave"-->
    <!--    @touchstart="preventSave"-->
    <VideoReel
      v-else
      :src="media.url"
      :postId="postId"

      class="relative z-20"/>
  </div>

</template>
<style>
.post-background::before {
  content: '';
  background-image: linear-gradient(0deg, rgba(0, 0, 0, .35) 0%, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, .35) 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>